import React, { useState } from "react";
import { calculateCVSS } from "./calculateCVSS";

const CVSSCalculator = () => {
  const [inputs, setInputs] = useState({
    attackVector: "N",
    attackComplexity: "L",
    privilegesRequired: "N",
    userInteraction: "N",
    confidentiality: "H",
    integrity: "N",
    availability: "N",
  });

  const [result, setResult] = useState({
    baseScore: "0.0",
    impact: 0,
    exploitability: 0,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const handleCalculate = () => {
    const cvssResult = calculateCVSS(inputs);
    setResult(cvssResult);
  };

  return (
    <div className="container mt-4">
      <div className="row">
        <div className="col-md-6">
          <form>
            <div className="mb-3">
              <label className="form-label">Angriffsvektor (AV)</label>
              <select
                name="attackVector"
                className="form-select"
                value={inputs.attackVector}
                onChange={handleInputChange}
              >
                <option value="N">Netzwerk (N) – Über das Internet</option>
                <option value="A">
                  Angrenzend (A) – Direkt verbundenes Netzwerk
                </option>
                <option value="L">
                  Lokal (L) – Zugriff auf Gerät erforderlich
                </option>
                <option value="P">
                  Physisch (P) – Physischer Kontakt erforderlich
                </option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Angriffskomplexität (AC)</label>
              <select
                name="attackComplexity"
                className="form-select"
                value={inputs.attackComplexity}
                onChange={handleInputChange}
              >
                <option value="L">Niedrig (L)</option>
                <option value="H">Hoch (H)</option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">
                Berechtigungsanforderung (PR)
              </label>
              <select
                name="privilegesRequired"
                className="form-select"
                value={inputs.privilegesRequired}
                onChange={handleInputChange}
              >
                <option value="N">Keine (N)</option>
                <option value="L">Niedrig (L)</option>
                <option value="H">Hoch (H)</option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Benutzereingriff (UI)</label>
              <select
                name="userInteraction"
                className="form-select"
                value={inputs.userInteraction}
                onChange={handleInputChange}
              >
                <option value="N">Nein (N)</option>
                <option value="R">Ja (R)</option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Vertraulichkeit (C)</label>
              <select
                name="confidentiality"
                className="form-select"
                value={inputs.confidentiality}
                onChange={handleInputChange}
              >
                <option value="H">Hoch (H)</option>
                <option value="L">Niedrig (L)</option>
                <option value="N">Keine (N)</option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Integrität (I)</label>
              <select
                name="integrity"
                className="form-select"
                value={inputs.integrity}
                onChange={handleInputChange}
              >
                <option value="H">Hoch (H)</option>
                <option value="L">Niedrig (L)</option>
                <option value="N">Keine (N)</option>
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label">Verfügbarkeit (A)</label>
              <select
                name="availability"
                className="form-select"
                value={inputs.availability}
                onChange={handleInputChange}
              >
                <option value="H">Hoch (H)</option>
                <option value="L">Niedrig (L)</option>
                <option value="N">Keine (N)</option>
              </select>
            </div>
          </form>
          <button className="btn btn-primary" onClick={handleCalculate}>
            Berechnen
          </button>
        </div>

        <div className="col-md-6">
          <h3>Ergebnis</h3>
          <p>
            <strong>Basiswert:</strong> {result.baseScore} <br />
          </p>
          <p>
            <strong>Impact:</strong> {result.impact.toFixed(2)}
          </p>
          <p>
            <strong>Exploitability:</strong> {result.exploitability.toFixed(2)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default CVSSCalculator;
